$( document ).ready(function() {

    window.util = {

        jsonParseWithSlice: function (jsonString) {

            return JSON.parse(jsonString.slice(1,-1));

        },

        isNullOrUndefined: function (val) {

            return typeof(val) === "undefined" 
                    || val === ""
                    || val === 0
                    || val === null;

        },

        getExtension: function (filename) {
            
            var _extension = filename.split('.').pop();
            return _extension.toLowerCase();

        },

        isImage: function (filename) {

            if (filename === null) { return false; }

            var _ext = this.getExtension(filename);
            var _validExtensions = ['gif', 'jpg', 'png', 'jpeg', 'bmp'];
            var _result = false;

            if (_.contains(_validExtensions, _ext)) { _result = true; }

            return _result;

        },

        decimalToHex: function(d, padding) {
            var hex = Number(d).toString(16);
            padding = typeof (padding) === "undefined" || padding === null ? padding = 2 : padding;

            while (hex.length < padding) {
                hex = "0" + hex;
            }

            return hex;
        },

        padHex: function(hex, padding) {
            padding = typeof (padding) === "undefined" || padding === null ? padding = 2 : padding;

            while (hex.length < padding) {
                hex = "0" + hex;
            }

            return hex;
        },

        log: function (type, message, object) {
            
            ub.errors.push({
                
                type: type,
                message: message,
                data: object,

            });
        },

        error: function (error){

            console.error(error);

        },

        collectionToArray: function(collection){

            var tempArray = [];

            _.each(collection, function(element){
                tempArray.push(element)
            });

            return tempArray;

        },
        
        toTitleCase: function(str){
            
            var s = str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});

            s = ub.data.specialCodes.getCode(s);

            return s;

        },
        truncate: function (str) {

            return str.replace(/^(.{9}).+/, "$1…");

        },
        dateFormat: function(created_at){
            var text = created_at;
            var serverDate = moment.utc(text).local().format('LLL'); 
            return serverDate;
        },

        dataSelector: function(preamble, obj){

            /// helper to compose selector when using multiple data-attributes, will print an error log
            /// if an invalid selector is detected

            var selector = preamble;

            _.each(obj, function(value, key){
                var el = "[data-" + key + "='" + value + "']";
                selector += el;
           })

            if($(selector).length > 0) {
                return $(selector);
            }
            else {
                console.error('Invalid Selector: ' + selector);
            }

        }

    };
    
    /// Call:   "arm trim".toTitleCase();
    /// Output: "Arm Trim"

    String.prototype.toTitleCase = function () {
 
        var fullStringValue = this.toString();
        var returnValue     = window.util.toTitleCase(fullStringValue.split('_').join(' '));
        
        return returnValue;

    };

    /// Call:   "Arm Trim".toCodeCase();
    /// Output: "arm_trim"

    String.prototype.toCodeCase = function () {

        var fullStringValue = this.toString();
        var returnValue     = fullStringValue.split(' ').join('_').toLowerCase();

        return returnValue;

    };

    String.prototype.toHyphenCase = function () {

        var fullStringValue = this.toString();
        var returnValue     = fullStringValue.replace(/[\*\^\'\!\/\(\)]/g, '').split(' ').join('-').toLowerCase();

        return returnValue;

    };

    String.prototype.prepareModifierLabel = function () {

        var fullStringValue = this.toString();
        var _result = '';        
        
        _result = fullStringValue.replace(' ', '');

        if (ub.config.uniform_brand === 'prolook') {
            let mergeModifierLabelOption = ['2 Ply reversible Pinnie'];
            let mergeModifierLabelIds = [6910, 6916, 6922, 11940];

            if (!ub.data.hasSeparatedSleeve.check(ub.config.material_id) && ub.config.sport !== '2023 Bag') {
                _result = fullStringValue.replace('left_','').replace('right_','');
            }
            if (_.contains(mergeModifierLabelOption, ub.config.option) || _.contains(mergeModifierLabelIds, ub.config.material_id)) {
                _result = fullStringValue.replace('front_body','body').replace('back_body','body').replace('left_','').replace('right_','');
            }
            if (ub.config.sport === "Crossbody Equipment Bag (Apparel)") {
                _result = fullStringValue.replace('top_panel','trim').replace('back_panel','trim').replace('front_','').replace('back_','');
            }
            // For Stock Volleyball Sport only
            if (ub.config.sport === "Stock Volleyball") {
                _result = fullStringValue.replace('back_waistband','body').replace('front_waistband','body').replace('left_leg','body').replace('right_leg','body');
            }

            if (ub.config.option === "Team Backpack") {
                _result = fullStringValue.replace('front_body','body');
            }

            if (ub.config.material_id === 15641) {
                _result = fullStringValue.replace('end_one_trim','back_edge').replace('end_two_trim', 'front_edge').replace('end_one_ring','back_ring').replace('end_two_ring','front_ring');
            }

            let ignoreIds = [18986, 18976];
            if (!_.contains(ignoreIds, ub.config.material_id) && ub.config.sport === "Track and Field" && ub.config.option === 'Decathlon Shorts') {
                _result = fullStringValue.replace('front_left_leg','body').replace('front_right_leg','body').replace('back_left_leg','body').replace('back_right_leg','body')
                .replace('front_','').replace('back_','').replace('left_','').replace('right_','');
            }

            if (_.contains(ignoreIds, ub.config.material_id)) {
                _result = fullStringValue.replace('front_left_leg','body').replace('front_right_leg','body').replace('back_left_leg','body').replace('back_right_leg','body')
                .replace('left_graphic','graphic').replace('right_graphic','graphic').replace('left_piping','piping').replace('right_piping','piping');
            }

            let mergeBaseballBlockPatterns = ['Perforated Baseball Tapered Pant', 'Perforated Baseball Traditional Pant', 'Perforated Fastpitch Pants', 'Perforated Football Pant', 'Pro Pant', 'Walk Off Perforated Pant', "RPO Pant"];
            if (_.contains(mergeBaseballBlockPatterns, ub.config.blockPattern)) {
                _result = fullStringValue.replace('front_left_leg','body').replace('front_right_leg','body').replace('back_left_leg','body').replace('back_right_leg','body').replace('crotch','body').replace('belt_loops','body')
                .replace('left_belt_loop_1','belt_loop').replace('left_belt_loop_2','belt_loop').replace('right_belt_loop_1','belt_loop').replace('right_belt_loop_2','belt_loop')
                .replace('front_','').replace('back_','').replace('left_','').replace('right_','');
            }

            let mergeBaseballBlockPatternsJersey = ['Perforated Baseball Jersey', 'Perforated Baseball Jersey ', 'Perforated Jersey Set-in', 'Walk Off Perforated Jersey'];
            if (_.contains(mergeBaseballBlockPatternsJersey, ub.config.blockPattern)) {
                _result = fullStringValue.replace('front_body','body').replace('back_body','body').replace('collar_back','collar').replace('left_front_collar','collar').replace('right_front_collar','collar')
                .replace('left_sleeve','sleeve').replace('right_sleeve','sleeve')
                .replace('front_','').replace('back_','').replace('left_','').replace('right_','');
            }

            let blockPatternsRPOJersey = ['Perforated Football Jersey', 'RPO Jersey'];
            if (_.contains(blockPatternsRPOJersey, ub.config.blockPattern)) {
                _result = fullStringValue.replace('front_bottom_panel','body').replace('back_bottom_panel','body')
                .replace('front_','').replace('back_','').replace('left_','').replace('right_','');
            }

            var cheerNeckOptions = ['Top Sleeveless', ' Top Sleeveless Open Back', 'Top Sleeveless Open Back', 'Top Sleeveless Racerback', 'Basic Top', 'Open Back Top', 'Racerback Top'];
            if (_.contains(cheerNeckOptions, ub.config.option)) {
                _result = fullStringValue.replace('back_upper_body','body')
                .replace('front_','').replace('back_','').replace('left_','').replace('right_','');
            }

            var cheerSkort = ['Cheer Skort', 'Cheer Skirt', 'Cheer Bottom'];
            if (_.contains(cheerSkort, ub.config.blockPattern)) {
                _result = fullStringValue.replace('waistband','body')
                .replace('front_','').replace('back_','').replace('left_','').replace('right_','');
            }

            var cheerMockNeckOptions = ['Top Long Sleeve Mock Neck', 'Top Long Sleeve V-Neck', 'Long Sleeve Mock Neck Liner', 'Long Sleeve V-Neck Liner'];
            if (_.contains(cheerMockNeckOptions, ub.config.option)) {
                _result = fullStringValue.replace('neck','body')
                .replace('front_','').replace('back_','').replace('left_','').replace('right_','');
            }

            var cheerLowerMen = ['Pant', 'Short'];
            if (ub.config.blockPattern === 'Cheer Bottom' && _.contains(cheerLowerMen, ub.config.option)) {
                _result = fullStringValue.replace('front_left_leg','body').replace('front_right_leg','body').replace('back_left_leg','body').replace('back_right_leg','body')
                .replace('front_','').replace('back_','').replace('left_','').replace('right_','');
            }

            if (ub.config.blockPattern === 'Cheer Top Men') {
                _result = fullStringValue.replace('front_','').replace('back_','').replace('left_','').replace('right_','');
            }

            let mergeCheer = ['Compression Pant']
            if (_.contains(mergeCheer, ub.config.blockPattern)) {
                _result = fullStringValue.replace('front_waistband','body').replace('back_waistband','body').replace('gusset','gusse').replace('left_leg','body').replace('right_leg','body')
                .replace('panel','panel').replace('panel','panel').replace('left_','').replace('right_','');
            }

        }

        // TEMPORARY FOR RIDDELL
        if (ub.config.uniform_brand === 'riddell') {

            if (_result === 'front_left_body_panel' || _result === 'front_right_body_panel') {

                _result = fullStringValue;

            } else if (_result === 'back_left_body_panel' || _result === 'back_left_body_panel') {

                _result = fullStringValue.replace('left_','').replace('right_','');

            } else {

                _result = fullStringValue.replace('left_','').replace('right_','');

            }

        }

       // _result = fullStringValue.replace('left_','').replace('right_','');
        _result = _result.toTitleCase();

        return _result;

    };

    String.prototype.lpad = function(padString, length) {
        var str = this;
        while (str.length < length)
            str = padString + str;
        return str;
    }

    String.prototype.rpad = function(padString, length) {
        var str = this;
        while (str.length < length)
            str = str + padString;
        return str;
    }

}); 